import { Currency as CurrencyLanguage } from '../../../../i18n'
import {
    LOCALE_DE_DE,
    LOCALE_EN_CA,
    LOCALE_EN_UK,
    LOCALE_EN_US,
    LOCALE_ES_MX,
    LOCALE_FR_CA,
    LOCALE_IT_IT
} from '../Constants/Locale'

type CurrencyDef = {
    currencyID: number
    descLangID: string
    localeStrDefault: string | null
    currencySymbol: string
    patternDefault: string
    groupingSeparatorDefault: string
    decimalSeparatorDefault: string
    currencyCode: string
    decimalPlaces: number
}

const CURRENCYDEF_POUND_UK_STANDARD: CurrencyDef = {
    currencyID: 0,
    descLangID: CurrencyLanguage.PoundUkStd,
    localeStrDefault: LOCALE_EN_UK,
    currencySymbol: '£',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'GBP',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_USA_STANDARD: CurrencyDef = {
    currencyID: 30,
    descLangID: CurrencyLanguage.DollarUsaStd,
    localeStrDefault: LOCALE_EN_US,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'USD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_USA_OTHER: CurrencyDef = {
    currencyID: 31,
    descLangID: CurrencyLanguage.DollarUsaOther,
    localeStrDefault: null,
    currencySymbol: 'US$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'USD',
    decimalPlaces: 2
}
export const CURRENCYDEF_EURO_ENGLISH_STANDARD: CurrencyDef = {
    currencyID: 60,
    descLangID: CurrencyLanguage.EuroGeneralStd,
    localeStrDefault: null,
    currencySymbol: '€',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'EUR',
    decimalPlaces: 2
}
export const CURRENCYDEF_EURO_FRENCH_STANDARD: CurrencyDef = {
    currencyID: 61,
    descLangID: CurrencyLanguage.EuroFrenchStd,
    localeStrDefault: null,
    currencySymbol: '€',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'EUR',
    decimalPlaces: 2
}
export const CURRENCYDEF_EURO_GERMAN_STANDARD: CurrencyDef = {
    currencyID: 62,
    descLangID: CurrencyLanguage.EuroGermanStd,
    localeStrDefault: LOCALE_DE_DE,
    currencySymbol: '€',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: '.',
    decimalSeparatorDefault: ',',
    currencyCode: 'EUR',
    decimalPlaces: 2
}
export const CURRENCYDEF_EURO_ITALIAN_STANDARD: CurrencyDef = {
    currencyID: 63,
    descLangID: CurrencyLanguage.EuroItalianStd,
    localeStrDefault: LOCALE_IT_IT,
    currencySymbol: '€',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: '.',
    decimalSeparatorDefault: ',',
    currencyCode: 'EUR',
    decimalPlaces: 2
}
export const CURRENCYDEF_YEN_JAPAN_STANDARD: CurrencyDef = {
    currencyID: 160,
    descLangID: CurrencyLanguage.YenJapanStd,
    localeStrDefault: null,
    currencySymbol: '¥',
    patternDefault: '¤#,##0',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'JPY',
    decimalPlaces: 0
}
export const CURRENCYDEF_DOLLAR_AUSTRALIA_STANDARD: CurrencyDef = {
    currencyID: 190,
    descLangID: CurrencyLanguage.DollarAustraliaStd,
    localeStrDefault: null,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'AUD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_AUSTRALIA_OTHER: CurrencyDef = {
    currencyID: 191,
    descLangID: CurrencyLanguage.DollarAustraliaOther,
    localeStrDefault: null,
    currencySymbol: 'A$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'AUD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_CANADA_ENGLISH_STANDARD: CurrencyDef = {
    currencyID: 220,
    descLangID: CurrencyLanguage.DollarCanadaEnglishStd,
    localeStrDefault: LOCALE_EN_CA,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CAD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_CANADA_FRENCH_STANDARD: CurrencyDef = {
    currencyID: 221,
    descLangID: CurrencyLanguage.DollarCanadaFrenchStd,
    localeStrDefault: LOCALE_FR_CA,
    currencySymbol: '$',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'CAD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_CANADA_ENGLISH_OTHER: CurrencyDef = {
    currencyID: 222,
    descLangID: CurrencyLanguage.DollarCanadaEnglishOther,
    localeStrDefault: null,
    currencySymbol: 'C$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CAD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_CANADA_FRENCH_OTHER: CurrencyDef = {
    currencyID: 223,
    descLangID: CurrencyLanguage.DollarCanadaFrenchOther,
    localeStrDefault: null,
    currencySymbol: 'C$',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'CAD',
    decimalPlaces: 2
}
export const CURRENCYDEF_FRANC_SWITZERLAND_FRENCH_STANDARD: CurrencyDef = {
    currencyID: 250,
    descLangID: CurrencyLanguage.FrancSchwitzerlandFrenchStd,
    localeStrDefault: null,
    currencySymbol: 'fr.',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CHF',
    decimalPlaces: 2
}
export const CURRENCYDEF_FRANC_SWITZERLAND_GERMAN_STANDARD: CurrencyDef = {
    currencyID: 251,
    descLangID: CurrencyLanguage.FrancSchwitzerlandGermanStd,
    localeStrDefault: null,
    currencySymbol: 'Fr.',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CHF',
    decimalPlaces: 2
}
export const CURRENCYDEF_FRANC_SWITZERLAND_ITALIAN_STANDARD: CurrencyDef = {
    currencyID: 252,
    descLangID: CurrencyLanguage.FrancSchwitzerlandItalianStd,
    localeStrDefault: null,
    currencySymbol: 'fr.',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CHF',
    decimalPlaces: 2
}
export const CURRENCYDEF_YUAN_CHINA_STANDARD: CurrencyDef = {
    currencyID: 280,
    descLangID: CurrencyLanguage.YuanChinaStd,
    localeStrDefault: null,
    currencySymbol: '¥',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'CNY',
    decimalPlaces: 2
}
export const CURRENCYDEF_PESO_MEXICO_STANDARD: CurrencyDef = {
    currencyID: 310,
    descLangID: CurrencyLanguage.PesoMexicoStd,
    localeStrDefault: LOCALE_ES_MX,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'MXN',
    decimalPlaces: 2
}
export const CURRENCYDEF_KRONA_SWEDEN_STANDARD: CurrencyDef = {
    currencyID: 340,
    descLangID: CurrencyLanguage.KronaSwedenStd,
    localeStrDefault: null,
    currencySymbol: 'kr',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'SEK',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_NEWZEALAND_STANDARD: CurrencyDef = {
    currencyID: 370,
    descLangID: CurrencyLanguage.DollarNewzealandStd,
    localeStrDefault: null,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'NZD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_NEWZEALAND_OTHER: CurrencyDef = {
    currencyID: 371,
    descLangID: CurrencyLanguage.DollarNewzealandOther,
    localeStrDefault: null,
    currencySymbol: 'NZ$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'NZD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_SINGAPORE_STANDARD: CurrencyDef = {
    currencyID: 400,
    descLangID: CurrencyLanguage.DollarSingaporeStd,
    localeStrDefault: null,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'SGD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_SINGAPORE_OTHER: CurrencyDef = {
    currencyID: 401,
    descLangID: CurrencyLanguage.DollarSingaporeOther,
    localeStrDefault: null,
    currencySymbol: 'S$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'SGD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_HONGKONG_STANDARD: CurrencyDef = {
    currencyID: 430,
    descLangID: CurrencyLanguage.DollarHongkongStd,
    localeStrDefault: null,
    currencySymbol: '$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'HKD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_HONGKONG_OTHER: CurrencyDef = {
    currencyID: 431,
    descLangID: CurrencyLanguage.DollarHongkongOther,
    localeStrDefault: null,
    currencySymbol: 'HK$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'HKD',
    decimalPlaces: 2
}
export const CURRENCYDEF_KRONE_NORWAY_STANDARD: CurrencyDef = {
    currencyID: 460,
    descLangID: CurrencyLanguage.KroneNorwayStd,
    localeStrDefault: null,
    currencySymbol: 'kr',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'NOK',
    decimalPlaces: 2
}
export const CURRENCYDEF_WON_SOUTHKOREA_STANDARD: CurrencyDef = {
    currencyID: 490,
    descLangID: CurrencyLanguage.WonSouthkoreaStd,
    localeStrDefault: null,
    currencySymbol: '\u20A9',
    patternDefault: '¤#,##0',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'KRW',
    decimalPlaces: 0
}
export const CURRENCYDEF_LIRA_TURKEY_STANDARD: CurrencyDef = {
    currencyID: 520,
    descLangID: CurrencyLanguage.LiraTurkeyStd,
    localeStrDefault: null,
    currencySymbol: '\u20BA',
    patternDefault: '#,##0.00 ¤',
    groupingSeparatorDefault: '.',
    decimalSeparatorDefault: ',',
    currencyCode: 'TRY',
    decimalPlaces: 2
}
export const CURRENCYDEF_RUPEE_INDIA_STANDARD: CurrencyDef = {
    currencyID: 550,
    descLangID: CurrencyLanguage.RupeeIndiaStd,
    localeStrDefault: null,
    currencySymbol: '\u20B9',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ',',
    decimalSeparatorDefault: '.',
    currencyCode: 'INR',
    decimalPlaces: 2
}
export const CURRENCYDEF_RUBLE_RUSSIA_STANDARD: CurrencyDef = {
    currencyID: 580,
    descLangID: CurrencyLanguage.RupleRussiaStd,
    localeStrDefault: null,
    currencySymbol: '\u20BD',
    patternDefault: '#,##0.00¤',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'RUB',
    decimalPlaces: 2
}
export const CURRENCYDEF_REAL_BRAZIL_STANDARD: CurrencyDef = {
    currencyID: 610,
    descLangID: CurrencyLanguage.RealBrazilStd,
    localeStrDefault: null,
    currencySymbol: 'R$',
    patternDefault: '¤#,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'BRL',
    decimalPlaces: 2
}
export const CURRENCYDEF_RAND_SOUTHAFRICA_STANDARD: CurrencyDef = {
    currencyID: 640,
    descLangID: CurrencyLanguage.RandSouthafricaStd,
    localeStrDefault: null,
    currencySymbol: 'R',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: ',',
    currencyCode: 'ZAR',
    decimalPlaces: 2
}
export const CURRENCYDEF_POUND_UK_ISO: CurrencyDef = {
    currencyID: 1000000,
    descLangID: CurrencyLanguage.PoundUkIso,
    localeStrDefault: null,
    currencySymbol: 'GBP',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'GBP',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_USA_ISO: CurrencyDef = {
    currencyID: 1000030,
    descLangID: CurrencyLanguage.DollarUsaIso,
    localeStrDefault: null,
    currencySymbol: 'USD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'USD',
    decimalPlaces: 2
}
export const CURRENCYDEF_EURO_ISO: CurrencyDef = {
    currencyID: 1000060,
    descLangID: CurrencyLanguage.EuroIso,
    localeStrDefault: null,
    currencySymbol: 'EUR',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'EUR',
    decimalPlaces: 2
}
export const CURRENCYDEF_YEN_JAPAN_ISO: CurrencyDef = {
    currencyID: 1000160,
    descLangID: CurrencyLanguage.YenJapanIso,
    localeStrDefault: null,
    currencySymbol: 'JPY',
    patternDefault: '¤ #,##0',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'JPY',
    decimalPlaces: 0
}
export const CURRENCYDEF_DOLLAR_AUSTRALIA_ISO: CurrencyDef = {
    currencyID: 1000190,
    descLangID: CurrencyLanguage.DollarAustraliaIso,
    localeStrDefault: null,
    currencySymbol: 'AUD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'AUD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_CANADA_ISO: CurrencyDef = {
    currencyID: 1000220,
    descLangID: CurrencyLanguage.DollarCanadaIso,
    localeStrDefault: null,
    currencySymbol: 'CAD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CAD',
    decimalPlaces: 2
}
export const CURRENCYDEF_FRANC_SWITZERLAND_ISO: CurrencyDef = {
    currencyID: 1000250,
    descLangID: CurrencyLanguage.FrancSchwitzerlandIso,
    localeStrDefault: null,
    currencySymbol: 'CHF',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CHF',
    decimalPlaces: 2
}
export const CURRENCYDEF_YUAN_CHINA_ISO: CurrencyDef = {
    currencyID: 1000280,
    descLangID: CurrencyLanguage.YuanChinaIso,
    localeStrDefault: null,
    currencySymbol: 'CNY',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'CNY',
    decimalPlaces: 2
}
export const CURRENCYDEF_PESO_MEXICO_ISO: CurrencyDef = {
    currencyID: 1000310,
    descLangID: CurrencyLanguage.PesoMexicoIso,
    localeStrDefault: null,
    currencySymbol: 'MXN',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'MXN',
    decimalPlaces: 2
}
export const CURRENCYDEF_KRONA_SWEDEN_ISO: CurrencyDef = {
    currencyID: 1000340,
    descLangID: CurrencyLanguage.KronaSwedenIso,
    localeStrDefault: null,
    currencySymbol: 'SEK',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'SEK',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_NEWZEALAND_ISO: CurrencyDef = {
    currencyID: 1000370,
    descLangID: CurrencyLanguage.DollarNewzealandIso,
    localeStrDefault: null,
    currencySymbol: 'NZD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'NZD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_SINGAPORE_ISO: CurrencyDef = {
    currencyID: 1000400,
    descLangID: CurrencyLanguage.DollarSingaporeIso,
    localeStrDefault: null,
    currencySymbol: 'SGD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'SGD',
    decimalPlaces: 2
}
export const CURRENCYDEF_DOLLAR_HONGKONG_ISO: CurrencyDef = {
    currencyID: 1000430,
    descLangID: CurrencyLanguage.DollarHongkongIso,
    localeStrDefault: null,
    currencySymbol: 'HKD',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'HKD',
    decimalPlaces: 2
}
export const CURRENCYDEF_KRONE_NORWAY_ISO: CurrencyDef = {
    currencyID: 1000460,
    descLangID: CurrencyLanguage.KroneNorwayIso,
    localeStrDefault: null,
    currencySymbol: 'NOK',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'NOK',
    decimalPlaces: 2
}
export const CURRENCYDEF_WON_SOUTHKOREA_ISO: CurrencyDef = {
    currencyID: 1000490,
    descLangID: CurrencyLanguage.WonSouthkoreaIso,
    localeStrDefault: null,
    currencySymbol: 'KRW',
    patternDefault: '¤ #,##0',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'KRW',
    decimalPlaces: 0
}
export const CURRENCYDEF_LIRA_TURKEY_ISO: CurrencyDef = {
    currencyID: 1000520,
    descLangID: CurrencyLanguage.LiraTurkeyIso,
    localeStrDefault: null,
    currencySymbol: 'TRY',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'TRY',
    decimalPlaces: 2
}
export const CURRENCYDEF_RUPEE_INDIA_ISO: CurrencyDef = {
    currencyID: 1000550,
    descLangID: CurrencyLanguage.RupeeIndiaIso,
    localeStrDefault: null,
    currencySymbol: 'INR',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'INR',
    decimalPlaces: 2
}
export const CURRENCYDEF_RUBLE_RUSSIA_ISO: CurrencyDef = {
    currencyID: 1000580,
    descLangID: CurrencyLanguage.RupleRussiaIso,
    localeStrDefault: null,
    currencySymbol: 'RUB',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'RUB',
    decimalPlaces: 2
}
export const CURRENCYDEF_REAL_BRAZIL_ISO: CurrencyDef = {
    currencyID: 1000610,
    descLangID: CurrencyLanguage.RealBrazilIso,
    localeStrDefault: null,
    currencySymbol: 'BRL',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'BRL',
    decimalPlaces: 2
}
export const CURRENCYDEF_RAND_SOUTHAFRICA_ISO: CurrencyDef = {
    currencyID: 1000640,
    descLangID: CurrencyLanguage.RandSouthafricaIso,
    localeStrDefault: null,
    currencySymbol: 'ZAR',
    patternDefault: '¤ #,##0.00',
    groupingSeparatorDefault: ' ',
    decimalSeparatorDefault: '.',
    currencyCode: 'ZAR',
    decimalPlaces: 2
}

export const CURRENCYDEF_DEFAULT = CURRENCYDEF_POUND_UK_STANDARD

export const allCurrencyDefs: CurrencyDef[] = [
    CURRENCYDEF_DOLLAR_AUSTRALIA_STANDARD,
    CURRENCYDEF_DOLLAR_CANADA_ENGLISH_STANDARD,
    CURRENCYDEF_DOLLAR_CANADA_FRENCH_STANDARD,
    CURRENCYDEF_YUAN_CHINA_STANDARD,
    CURRENCYDEF_EURO_ENGLISH_STANDARD,
    CURRENCYDEF_EURO_FRENCH_STANDARD,
    CURRENCYDEF_EURO_GERMAN_STANDARD,
    CURRENCYDEF_EURO_ITALIAN_STANDARD,
    CURRENCYDEF_POUND_UK_STANDARD,
    CURRENCYDEF_DOLLAR_HONGKONG_STANDARD,
    CURRENCYDEF_RUPEE_INDIA_STANDARD,
    CURRENCYDEF_YEN_JAPAN_STANDARD,
    CURRENCYDEF_WON_SOUTHKOREA_STANDARD,
    CURRENCYDEF_PESO_MEXICO_STANDARD,
    CURRENCYDEF_DOLLAR_NEWZEALAND_STANDARD,
    CURRENCYDEF_RUBLE_RUSSIA_STANDARD,
    CURRENCYDEF_DOLLAR_SINGAPORE_STANDARD,
    CURRENCYDEF_LIRA_TURKEY_STANDARD,
    CURRENCYDEF_DOLLAR_USA_STANDARD,
    CURRENCYDEF_RAND_SOUTHAFRICA_STANDARD,
    //
    CURRENCYDEF_DOLLAR_AUSTRALIA_OTHER,
    CURRENCYDEF_REAL_BRAZIL_STANDARD,
    CURRENCYDEF_DOLLAR_CANADA_ENGLISH_OTHER,
    CURRENCYDEF_DOLLAR_CANADA_FRENCH_OTHER,
    CURRENCYDEF_FRANC_SWITZERLAND_FRENCH_STANDARD,
    CURRENCYDEF_FRANC_SWITZERLAND_GERMAN_STANDARD,
    CURRENCYDEF_FRANC_SWITZERLAND_ITALIAN_STANDARD,
    CURRENCYDEF_DOLLAR_HONGKONG_OTHER,
    CURRENCYDEF_KRONE_NORWAY_STANDARD,
    CURRENCYDEF_DOLLAR_NEWZEALAND_OTHER,
    CURRENCYDEF_KRONA_SWEDEN_STANDARD,
    CURRENCYDEF_DOLLAR_SINGAPORE_OTHER,
    CURRENCYDEF_DOLLAR_USA_OTHER,
    //
    CURRENCYDEF_DOLLAR_AUSTRALIA_ISO,
    CURRENCYDEF_REAL_BRAZIL_ISO,
    CURRENCYDEF_DOLLAR_CANADA_ISO,
    CURRENCYDEF_FRANC_SWITZERLAND_ISO,
    CURRENCYDEF_YUAN_CHINA_ISO,
    CURRENCYDEF_EURO_ISO,
    CURRENCYDEF_POUND_UK_ISO,
    CURRENCYDEF_DOLLAR_HONGKONG_ISO,
    CURRENCYDEF_RUPEE_INDIA_ISO,
    CURRENCYDEF_YEN_JAPAN_ISO,
    CURRENCYDEF_WON_SOUTHKOREA_ISO,
    CURRENCYDEF_PESO_MEXICO_ISO,
    CURRENCYDEF_KRONE_NORWAY_ISO,
    CURRENCYDEF_DOLLAR_NEWZEALAND_ISO,
    CURRENCYDEF_RUBLE_RUSSIA_ISO,
    CURRENCYDEF_KRONA_SWEDEN_ISO,
    CURRENCYDEF_DOLLAR_SINGAPORE_ISO,
    CURRENCYDEF_LIRA_TURKEY_ISO,
    CURRENCYDEF_DOLLAR_USA_ISO,
    CURRENCYDEF_RAND_SOUTHAFRICA_ISO
]

/**
 * Returns currency symbol for currency specified, empty string if currency is not found.
 *
 * @param currencyID Identifier of the currency.
 */
export const mapCurrencyIdToCurrencySymbol = (currencyID: number): string => {
    const currency = allCurrencyDefs.find((currencyDef) => currencyDef.currencyID === currencyID)
    return currency ? currency.currencySymbol : ''
}

export default allCurrencyDefs
